class Tab {
    constructor(c = {}) {
        this.tabsTriggerParent = c.tabsTriggerParent
        this.tabsContentParent = c.tabsContentParent
            // 
        this.triggers = this.tabsTriggerParent.querySelectorAll('.wu-tab')
        this.contents = this.tabsContentParent.querySelectorAll('.wu-tabs__content--pane')

        this.init()
    }
    init() {
        this.listeners()
    }
    listeners() {
        for (let i = 0; i < this.triggers.length; i++) {
            this.triggers[i].addEventListener('click', e => {
                let id = e.currentTarget.getAttribute("id")
                this.triggersClickHandler(i, id)
                window.dispatchEvent(new CustomEvent('scroll'))
            })
        }
    }
    triggersClickHandler(index, id) {
        // triggers
        for (let i = 0; i < this.triggers.length; i++) {
            this.triggers[i].classList.remove('wu-tab--active')
        }
        this.triggers[index].classList.add('wu-tab--active')

        //contents
        for (let i = 0; i < this.contents.length; i++) {
            this.contents[i].classList.remove('active')
        }
        this.tabsContentParent.querySelector(id).classList.add('active')
    }
}

let tabsTriggerParent = document.querySelectorAll('.wu-tabs')
let tabsContentParent = document.querySelectorAll('.wu-tabs__content')
if (
    tabsTriggerParent.length > 0 &&
    tabsContentParent.length > 0 &&
    tabsTriggerParent.length === tabsContentParent.length
) {
    for (let i = 0; i < tabsTriggerParent.length; i++) {
        new Tab({
            tabsTriggerParent: tabsTriggerParent[i],
            tabsContentParent: tabsContentParent[i]
        })
    }
}